module.exports = __webpack_public_path__ + "img/zfbCode.6031195e.jpg";